// eslint-disable-next-line
const fulltax_2024 = [
    {
        section: 'General Information',
        fields: [
            {
                name: 'filingStatus',
                text: 'Filing Status',
                type: 'string',
                options: [
                    'Single',
                    'Married Filing Jointly',
                    'Married Filing Separately',
                    'Head of Household',
                    'Qualifying Surviving Spouse',
                ],
                inputType: 'select',
                defaultValue: 'Single',
                noHasFlag: true,
            },
        ],
    },
    {
        section: 'Form 1040',
        tabActive: true,
        fields: [
            {
                name: 'wages',
                text: 'Total amount from Form(s) W-2, box 1',
                line: 'Line 1a',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'householdWages',
                text: 'Household employee wages',
                line: 'Line 1b',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'tipIncome',
                text: 'Tip income',
                line: 'Line 1c',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'medicalWaiverPayments',
                text: 'Medicaid waiver payments',
                line: 'Line 1d',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'taxableDependentBenefits',
                text: 'Taxable dependent care benefits',
                line: 'Line 1e',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'employerAdoptionBenefits',
                text: 'Employer-provided adoption benefits',
                line: 'Line 1f',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'wagesFrom8919',
                text: 'Wages from form 8919',
                line: 'Line 1g',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'otherEarnedIncome',
                text: 'Other earned income',
                line: 'Line 1h',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'sum1a1h',
                text: 'Add lines 1a through 1h',
                line: 'Line 1z',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'taxExemptInterest',
                text: 'Tax-exempt interest',
                line: 'Line 2a',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'taxInterest',
                text: 'Taxable interest',
                line: 'Line 2b',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'qualifiedDividends',
                text: 'Qualified dividends',
                line: 'Line 3a',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'totalDividends',
                text: 'Ordinary dividends',
                line: 'Line 3b',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'iraDistribution',
                text: 'IRA distributions',
                line: 'Line 4a',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'taxableIRA',
                text: 'IRA distributions taxable amount',
                line: 'Line 4b',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'pension',
                text: 'Pensions and annuities',
                line: 'Line 5a',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'taxablePension',
                text: 'Pensions and annuities taxable amount',
                line: 'Line 5b',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'socialSecurityBenefits',
                text: 'Social security benefits',
                line: 'Line 6a',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'socialSecurity',
                text: 'Social security benefits taxable amount',
                line: 'Line 6b',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'capitalGainOrLoss',
                text: 'Capital gain or (loss)',
                line: 'Line 7',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'otherIncome',
                text: 'Additional Income',
                line: 'Line 8',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'totalIncome',
                text: 'Total income',
                line: 'Line 9',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'adjustedIncome',
                text: 'Adjustments to income',
                line: 'Line 10',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'adjustedGrossIncome',
                text: 'Adjusted gross income',
                line: 'Line 11',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'standardDeductions',
                text: 'Standard deductions or itemized deductions',
                line: 'Line 12',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'qbIncome',
                text: 'Qualified business income deductions',
                line: 'Line 13',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'sumDeductions',
                text: 'Sum of deductions',
                line: 'Line 14',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'taxableIncome',
                text: 'Taxable income',
                line: 'Line 15',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'taxes',
                text: 'Tax',
                line: 'Line 16',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'line17_1040',
                text: 'Amount from schedule 2 line 3',
                line: 'Line 17',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'line18_1040',
                text: 'Add lines 16 and 17',
                line: 'Line 18',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'qualifyingDependentCreditClaimed',
                text: 'Child tax credit or credit for other dependents',
                line: 'Line 19',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'line20_1040',
                text: 'Amount from schedule 3 line 8',
                line: 'Line 20',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'line21_1040',
                text: 'Add lines 19 and 20',
                line: 'Line 21',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'line22_1040',
                text: 'Substract line 21 from line 18',
                line: 'Line 22',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'otherTaxesWithSelfEmployment',
                text: 'Other taxes',
                line: 'Line 23',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'totalTax',
                text: 'Total tax',
                line: 'Line 24',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'federalIncomeTaxWithheld',
                text: 'Federal income tax withheld from Form(s) W-2, 1099 and others',
                line: 'Line 25d',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'estimatedTaxPaymentsAmountForLastYear',
                text: '2024 estimated tax payments and amount applied from 2023 return',
                line: 'Line 26',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'earnedIncomeCredit',
                text: 'Earned income credit (EIC)',
                line: 'Line 27',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'additionalChildTaxCredit',
                text: 'Additional child tax credit',
                line: 'Line 28',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'americanOpportunityCreditTaken',
                text: 'American opportunity credit from Form 8863, line 8',
                line: 'Line 29',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'recoveryRebateCredit',
                text: 'Recovery rebate credit',
                line: 'Line 30',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'amountfromSchedule3line15',
                text: 'Amount from Schedule 3, line 15',
                line: 'Line 31',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'totalOtherPayments',
                text: 'Total other payments and refundable credits',
                line: 'Line 32',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'totalPayments',
                text: 'Total payments',
                line: 'Line 33',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
        ],
    },
    {
        section: 'Schedule 1',
        fields: [
            {
                name: 'clientHasSchedule1',
                text: 'Has Schedule 1?',
                type: 'string',
                options: ['Yes', 'No'],
                inputType: 'radiobutton',
                defaultValue: 'No',
            },
            {
                name: 'taxableRefunds',
                text: 'Taxable refunds',
                line: 'Line 1',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'alimonyReceived',
                text: 'Alimony received',
                line: 'Line 2a',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'businessIncome',
                text: 'Business income/loss',
                line: 'Line 3',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'otherGainsOrLosses',
                text: 'Other gains or losses',
                line: 'Line 4',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'rentalRealEstate',
                text: 'Rental real estate, royalties, partnerships, etc.',
                line: 'Line 5',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'farmIncome',
                text: 'Farm income or loss',
                line: 'Line 6',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'unemployementCompensation',
                text: 'Unemployment compensation',
                line: 'Line 7',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'otherIncome8a',
                text: 'Net operating loss',
                line: 'Line 8a',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'otherIncome8b',
                text: 'Gambling',
                line: 'Line 8b',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'otherIncome8c',
                text: 'Cancellation of debt',
                line: 'Line 8c',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'otherIncome8d',
                text: 'Foreign earned income exclusion from Form 2555',
                line: 'Line 8d',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'otherIncome8e',
                text: 'Income from Form 8853',
                line: 'Line 8e',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'otherIncome8f',
                text: 'Income from Form 8889',
                line: 'Line 8f',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'otherIncome8g',
                text: 'Alaska permanent fund dividends',
                line: 'Line 8g',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'otherIncome8h',
                text: 'Jury duty pay',
                line: 'Line 8h',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'otherIncome8i',
                text: 'Prizes and awards',
                line: 'Line 8i',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'otherIncome8j',
                text: 'Activity not engaged in profit income',
                line: 'Line 8j',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'otherIncome8k',
                text: 'Stock options',
                line: 'Line 8k',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'otherIncome8l',
                text: 'Income from rental of personal property',
                line: 'Line 8l',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'otherIncome8m',
                text: 'Olympic and paralympic medals and USOC prize money',
                line: 'Line 8m',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'otherIncome8n',
                text: 'Section 951(a) inclusion',
                line: 'Line 8n',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'otherIncome8o',
                text: 'Section 951A(a) inclusion',
                line: 'Line 8o',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'otherIncome8p',
                text: 'Section 461(l) excess business loss adjustment',
                line: 'Line 8p',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'otherIncome8q',
                text: 'Taxable distributions from and ABLE account',
                line: 'Line 8q',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'otherIncome8r',
                text: 'Scholarship and fellowship grants not reported on W-2',
                line: 'Line 8r',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'otherIncome8s',
                text: 'Nontaxable amount of Medicaid waiver payments',
                line: 'Line 8s',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'otherIncome8t',
                text: 'Pension or annuity from a nonquialified deferred compensation plan',
                line: 'Line 8t',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'otherIncome8u',
                text: 'Wages earned while incarcerated',
                line: 'Line 8u',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'otherIncome8v',
                text: 'Digital assets received as ordinary income not reported elsewhere',
                line: 'Line 8v',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'otherIncome8z',
                text: 'Other income',
                line: 'Line 8z',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'additionalIncomeTotal',
                text: 'Total other income',
                line: 'Line 9',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'sum1to9',
                text: 'Additional income',
                line: 'Line 10',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'educatorExpenses',
                text: 'Educator expenses',
                line: 'Line 11',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'certainBusinessExpenses',
                text: 'Certain business expenses',
                line: 'Line 12',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'healthSavings',
                text: 'Health savings account deduction',
                line: 'Line 13',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'movingExpenses',
                text: 'Moving expenses for members of the Armed Forces',
                line: 'Line 14',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'deductibleOfSelfEmployment',
                text: 'Deductible part of self-employment',
                line: 'Line 15',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'selfEmployedSEP',
                text: 'Self-employment SEP, SIMPLE and qualified plans',
                line: 'Line 16',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'selfEmployedHealthInsurance',
                text: 'Self-employment health insurance deduction',
                line: 'Line 17',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'penaltyEarlyWithdrawal',
                text: 'Penalty on early withdrawl or savings',
                line: 'Line 18',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'alimonyPaid',
                text: 'Alimony paid',
                line: 'Line 19a',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'iraDeduction',
                text: 'IRA deduction',
                line: 'Line 20',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'studentLoanInterestDeduction',
                text: 'Student loan interest deduction',
                line: 'Line 21',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            // {
            //     name: 'forFutureUseSch1',
            //     text: 'Reserved for future use',
            //     line: 'Line 22',
            //     type: 'number',
            //     inputType: "number",
            //.    defaultValue: 0
            // },
            {
                name: 'archerMSADeduction',
                text: 'Archer MSA Deduction',
                line: 'Line 23',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'juryDuty',
                text: 'Jury duty pay',
                line: 'Line 24a',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'deductibleExpenses',
                text: 'Deductible expenses related to income reported on line 8l from the rental of personal property engaged in for profit',
                line: 'Line 24b',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'nontaxableAmountOlympicMedals',
                text: 'Nontaxable amount of the value of Olympic and Paralympic medals',
                line: 'Line 24c',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'reforestationAmortization',
                text: 'Reforestation amortization and expenses ',
                line: 'Line 24d',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'repaymentOfUnemployedBenefits',
                text: 'Repayment of supplemental unemployment benefits under the trade act of 1974',
                line: 'Line 24e',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'contributionsToSection501',
                text: 'Contributions to section 501(c)(18)(D) pension plans',
                line: 'Line 24f',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'contributionsToSection403',
                text: 'Contributions by certain chaplains to section 403(b) plans',
                line: 'Line 24g',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'attorneyFeesDiscriminationClaims',
                text: 'Attorney fees and court costs for actions involving discrimination claims',
                line: 'Line 24h',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'attorneyFeesIRSHelp',
                text: 'Attorney fees and court costs in connection with and award from the IRS',
                line: 'Line 24i',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'housingDeduction',
                text: 'Housing deduction from Form 2555',
                line: 'Line 24j',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'excessDeductions',
                text: 'Excess deductions of section 67(e) expenses from Schedule K-1',
                line: 'Line 24k',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'otherAdjustmens',
                text: 'Other adjustments',
                line: 'Line 24z',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'totalOtherAdjustments',
                text: 'Total other adjustmens',
                line: 'Line 25',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'adjustmentToIncome',
                text: 'Adjustments to income',
                line: 'Line 26',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
        ],
    },
    {
        section: 'Schedule 2',
        fields: [
            {
                name: 'clientHasSchedule2',
                text: 'Has Schedule 2?',
                type: 'string',
                options: ['Yes', 'No'],
                inputType: 'radiobutton',
                defaultValue: 'No',
            },
            {
                name: 'schedule2line1z',
                text: 'Add lines 1a through 1y',
                line: 'Line 1z',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'excessAdvPremiumTaxCredit',
                text: 'Excess advance premium tax credit repayment',
                line: 'Line 1a',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'alternativeMinTax',
                text: 'Alternative minimun tax',
                line: 'Line 2',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'sum1and2',
                text: 'Add lines 1z and 2',
                line: 'Line 3',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'selfEmploymentTaxSch3',
                text: 'Self-employment tax',
                line: 'Line 4',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'socialSecurityTip',
                text: 'Social security and Medicare tax on unreported tip income',
                line: 'Line 5',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'uncollectedSocialSecurity',
                text: 'Uncollected social security and Medicare tax on wages',
                line: 'Line 6',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'totalAdditionalSocialSecurity',
                text: 'Total additional social security and Medicare tax',
                line: 'Line 7',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'additionalTaxOnIRA',
                text: 'Additional tax on IRAs or other tax-favored accounts',
                line: 'Line 8',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'householdEmploymentTaxes',
                text: 'Household employment taxes',
                line: 'Line 9',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'repaymentFirstTimeBuyer',
                text: 'Repayment of first-time homebuyer credit',
                line: 'Line 10',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'additionalMedicare',
                text: 'Additional Medicare tax',
                line: 'Line 11',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'netInvestmentIncomeTax',
                text: 'Net investment income tax',
                line: 'Line 12',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'uncollectedSocialSecurityOnTips',
                text: 'Uncollected social security and Medicare or RRTA tax on tips',
                line: 'Line 13',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'interestOnTax',
                text: 'Interest on tax due on installment income from the sale of certain residential lots and timeshares',
                line: 'Line 14',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'interestOnDeferredTax',
                text: 'Interest on the deferred tax on gain from certain installment sales with a sales price over $150,000',
                line: 'Line 15',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'recaptureLowIncome',
                text: 'Recapture of low-income housing credit',
                line: 'Line 16',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'recaptureOtherCredits',
                text: 'Recapture of other credits',
                line: 'Line 17a',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'recaptureFederalMortage',
                text: 'Recapture of federal mortgage subsidy',
                line: 'Line 17b',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'additionalTaxHSA',
                text: 'Additional tax on HSA distributions',
                line: 'Line 17c',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'additionalTaxHSAdidntRemainElegibleIndividual',
                text: "Additional tax on an HSA because you didn't remain an eligible individual",
                line: 'Line 17d',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'additionalTaxArcherMSA',
                text: 'Additional tax on Archer MSA distributions',
                line: 'Line 17e',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'additionalTaxMedicareAdvantageMSA',
                text: 'Additional tax on Medicare Advantage MSA distributions',
                line: 'Line 17f',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'recaptureOfCharitableContributions',
                text: 'Recapture of a charitable contribution deduction related to a fractional interest in tangible personal property',
                line: 'Line 17g',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'incomeFromNonqualifiedCompesationPlan',
                text: 'Income you received from a nonqualified deferred compensation plan that fails to meet the requirements of section 409A ',
                line: 'Line 17h',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'incomeFromNonqualifiedCompesationPlan457A',
                text: 'Compensation you received from a nonqualified deferred compensation plan described in section 457A',
                line: 'Line 17i',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'section72ExcessBenefitsTax',
                text: 'Section 72(m)(5) excess benefits tax',
                line: 'Line 17j',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'goldenParachutePayments',
                text: 'Golden parachute payments',
                line: 'Line 17k',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'taxAccumulationDistributionOfTrusts',
                text: 'Tax on accumulation distribution of trusts',
                line: 'Line 17l',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'exciseTaxOnInsiderStock',
                text: 'Excise tax on insider stock compensation from an expatriated corporation',
                line: 'Line 17m',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'lookbackInterestSection167or460',
                text: 'Look-back interest under section 167(g) or 460(b) from Form 8697 or 8866',
                line: 'Line 17n',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'taxNonEffectivelyConnectedIncome',
                text: 'Tax on non-effectively connected income for any part of the year you were a nonresident alien',
                line: 'Line 17o',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'interestForm8621line16f',
                text: 'Any interest from Form 8621, line 16f',
                line: 'Line 17p',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'interestForm8621line24',
                text: 'Any interest from Form 8621, line 24',
                line: 'Line 17q',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'anyOtherTaxes',
                text: 'Any other taxes',
                line: 'Line 17z',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'totalAdditionalTaxes',
                text: 'Total additional taxes',
                line: 'Line 18',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'reservedForFutureUse',
                text: 'Recapture of net EPE from Form 4255, line 1d, column (l)',
                line: 'Line 19',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'section965',
                text: 'Section 965 net tax liability installment from Form 965-A',
                line: 'Line 20',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'totalOtherTaxes',
                text: 'Total other taxes',
                line: 'Line 21',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
        ],
    },
    {
        section: 'Schedule 3',
        fields: [
            {
                name: 'clientHasSchedule3',
                text: 'Has Schedule 3?',
                type: 'string',
                options: ['Yes', 'No'],
                inputType: 'radiobutton',
                defaultValue: 'No',
            },
            {
                name: 'foreignTax',
                text: 'Foreign tax',
                line: 'Line 1',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'creditForChildCareTF',
                text: 'Credit for child/dependent care?',
                line: 'Line 2',
                type: 'string',
                options: ['Yes', 'No'],
                inputType: 'radiobutton',
                defaultValue: 'No',
            },
            {
                name: 'creditForChildCare',
                text: 'Credit for child and dependent care expenses',
                line: 'Line 2',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'educationCredits',
                text: 'Education credits',
                line: 'Line 3',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'retiramentSavings',
                text: 'Retirament savings contributions credit',
                line: 'Line 4',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'schedule3line5a',
                text: 'Residential clean energy credit',
                line: 'Line 5a',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'schedule3line5b',
                text: 'Energy efficient home improvement credit',
                line: 'Line 5b',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'generalBusinessCredit',
                text: 'General business credit',
                line: 'Line 6a',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'creditForPriorYearMinimunTax',
                text: 'Credit for prior year minimun tax',
                line: 'Line 6b',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'adoptionCredit',
                text: 'Adoption credit',
                line: 'Line 6c',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'creditForEldery',
                text: 'Credit for elderly or disabled',
                line: 'Line 6d',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            // {
            //     name: 'alternativeMotorVehicleCredit',
            //     text: 'Alternative motor vehicle credit',
            //     line: 'Line 6e',
            //     type: 'number',
            //     inputType: "number",
            //.    defaultValue: 0
            // },
            {
                name: 'qualifiedPlugInMotorVehicleCredit',
                text: 'Clean vehicle credit',
                line: 'Line 6f',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'mortgageInterestCredit',
                text: 'Mortgage interest credit',
                line: 'Line 6g',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'columbiaFirstTimeBuyer',
                text: 'District of Columbia first-time homebuyer credit',
                line: 'Line 6h',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'qualifiedElectricVehicleCredit',
                text: 'Qualified electric vehicle credit',
                line: 'Line 6i',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'alternativeFuelVehicleCredit',
                text: 'Alternative fuel vehicle refueling property credit',
                line: 'Line 6j',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'creditToHoldersTaxCreditsBonds',
                text: 'Credit to holders of tax credit bonds',
                line: 'Line 6k',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'amountOnForm8978',
                text: 'Amount on Form 8978, line 14',
                line: 'Line 6l',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'schedule3line6m',
                text: 'Credit for previously owned clean vehicles',
                line: 'Line 6m',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'otherNonRefundableCredits',
                text: 'Other nonrefundable credits',
                line: 'Line 6z',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                //name: 'nonRefundableCredits',
                name: 'nonrefundableCredits',
                text: 'Total other non refundable credits',
                line: 'Line 7',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'estimatedTax',
                text: 'Add lines 1 through 4, 5a, 5b, and 7',
                line: 'Line 8',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'netPremiumTaxCredit',
                text: 'Net premium tax credit',
                line: 'Line 9',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'requestForExtension',
                text: 'Amount paid with request for extension to file',
                line: 'Line 10',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'excessSocialSecurity',
                text: 'Excess social security and tier 1 RRTA tax withheld',
                line: 'Line 11',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'creditForFederalTaxFuels',
                text: 'Credit for federal tax on fuels',
                line: 'Line 12',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'form2439',
                text: 'Form 2439',
                line: 'Line 13a',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'qualifiedSickCredits',
                text: 'Section 1341 credit for repayment of amounts included in income from earlier years',
                line: 'Line 13b',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'healthCoverageCredit',
                text: 'Net elective payment election amount from Form 3800',
                line: 'Line 13c',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'creditForRepayment',
                text: 'Deferred amount of net 965 tax liability',
                line: 'Line 13d',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'otherPaymentsOrRefundableCredits',
                text: 'Other payments or refundable credits',
                line: 'Line 13z',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'refundableCredits',
                text: 'Total other payments or refundable credits',
                line: 'Line 14',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'sum9to14',
                text: 'Add lines 9 through 12 and 14',
                line: 'Line 15',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
        ],
    },
    {
        section: 'Schedule A',
        fields: [
            {
                name: 'clientHasScheduleA',
                text: 'Has Schedule A?',
                type: 'string',
                options: ['Yes', 'No'],
                inputType: 'radiobutton',
                defaultValue: 'No',
            },
            {
                name: 'medicalExpenses',
                text: 'Medical and dental expenses',
                line: 'Line 1',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                //name: 'scheduleA_line2',
                name: 'scheduleA2',
                text: 'Enter amount from Form 1040 or 1040-SR, line 11',
                line: 'Line 2',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'medicalExpenses2',
                text: 'Multiply line 2 by 7.5%',
                line: 'Line 3',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'medicalExpenses3',
                text: 'Subtract line 3 from line 1',
                line: 'Line 4',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'taxesYouPaid5a',
                text: 'State and local income taxes or general sales taxes',
                line: 'Line 5a',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'taxesYouPaid5b',
                text: 'State and local real estate taxes',
                line: 'Line 5b',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'taxesYouPaid5c',
                text: 'State and local personal property taxes',
                line: 'Line 5c',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'taxesYouPaid5d',
                text: 'Add lines 5a through 5c',
                line: 'Line 5d',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'taxesYouPaid5e',
                text: 'Enter the smaller of line 5d or $10,000',
                line: 'Line 5e',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'scheduleA6',
                text: 'Other taxes',
                line: 'Line 6',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'taxesYouPaid',
                text: 'Add lines 5e and 6',
                line: 'Line 7',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'mortgageInterests',
                text: 'Home mortgage interest and points reported to you on Form 1098',
                line: 'Line 8a',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'mortgageInterestsNotReported',
                text: 'Home mortgage interest not reported to you on Form 1098',
                line: 'Line 8b',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'pointsNotReported',
                text: 'Points not reported to you on Form 1098',
                line: 'Line 8c',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            // {
            //     name: 'mortgageInsurancePremiums',
            //     text: 'Mortgage insurance premiums',
            //     line: 'Line 8d',
            //     type: 'number',
            //     inputType: "number",
            //.    defaultValue: 0
            // },
            {
                name: 'sumOfLines8',
                text: 'Add lines 8a through 8c',
                line: 'Line 8e',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'investmentInterest',
                text: 'Investment interest',
                line: 'Line 9',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'interestYouPaid',
                text: 'Add lines 8e and 9',
                line: 'Line 10',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'giftsByCash',
                text: 'Gifts by cash or check',
                line: 'Line 11',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'giftsByLand',
                text: 'Other than by cash or check',
                line: 'Line 12',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'scheduleA13',
                text: 'Carryover from prior year',
                line: 'Line 13',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'giftsToCharity',
                text: 'Add lines 11 through 13',
                line: 'Line 14',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'casualtyLosses',
                text: 'Casualty and theft loss(es) from a federally declared disaster',
                line: 'Line 15',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                //name: 'otherItemizedDeductions',
                name: 'scheduleA16',
                text: 'Other itemized deductions',
                line: 'Line 16',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'summationsItemizedDeductions',
                text: 'Total itemized deductions',
                line: 'Line 17',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
        ],
    },
    {
        section: 'Schedule B Part 1',
        fields: [
            {
                name: 'clientHasScheduleB',
                text: 'Has Schedule B?',
                type: 'string',
                options: ['Yes', 'No'],
                inputType: 'radiobutton',
                defaultValue: 'No',
            },
            {
                name: 'scheduleb_1_0_text',
                text: 'scheduleb_1_0_text',
                line: 'Line 0 TEXT',
                type: 'string',
                inputType: 'text',
                defaultValue: '',
            },
            {
                name: 'scheduleb_1_0_amount',
                text: 'scheduleb_1_0_amount',
                line: 'Line 0 AMOUNT',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'scheduleb_1_1_text',
                text: 'scheduleb_1_1_text',
                line: 'Line 1 TEXT',
                type: 'string',
                inputType: 'text',
                defaultValue: '',
            },
            {
                name: 'scheduleb_1_1_amount',
                text: 'scheduleb_1_1_amount',
                line: 'Line 1 AMOUNT',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'scheduleb_1_2_text',
                text: 'scheduleb_1_2_text',
                line: 'Line 2 TEXT',
                type: 'string',
                inputType: 'text',
                defaultValue: '',
            },
            {
                name: 'scheduleb_1_2_amount',
                text: 'scheduleb_1_2_amount',
                line: 'Line 2 AMOUNT',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'scheduleb_1_3_text',
                text: 'scheduleb_1_3_text',
                line: 'Line 3 TEXT',
                type: 'string',
                inputType: 'text',
                defaultValue: '',
            },
            {
                name: 'scheduleb_1_3_amount',
                text: 'scheduleb_1_3_amount',
                line: 'Line 3 AMOUNT',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'scheduleb_1_4_text',
                text: 'scheduleb_1_4_text',
                line: 'Line 4 TEXT',
                type: 'string',
                inputType: 'text',
                defaultValue: '',
            },
            {
                name: 'scheduleb_1_4_amount',
                text: 'scheduleb_1_4_amount',
                line: 'Line 4 AMOUNT',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'scheduleb_1_5_text',
                text: 'scheduleb_1_5_text',
                line: 'Line 5 TEXT',
                type: 'string',
                inputType: 'text',
                defaultValue: '',
            },
            {
                name: 'scheduleb_1_5_amount',
                text: 'scheduleb_1_5_amount',
                line: 'Line 5 AMOUNT',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'scheduleb_1_6_text',
                text: 'scheduleb_1_6_text',
                line: 'Line 6 TEXT',
                type: 'string',
                inputType: 'text',
                defaultValue: '',
            },
            {
                name: 'scheduleb_1_6_amount',
                text: 'scheduleb_1_6_amount',
                line: 'Line 6 AMOUNT',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'scheduleb_1_7_text',
                text: 'scheduleb_1_7_text',
                line: 'Line 7 TEXT',
                type: 'string',
                inputType: 'text',
                defaultValue: '',
            },
            {
                name: 'scheduleb_1_7_amount',
                text: 'scheduleb_1_7_amount',
                line: 'Line 7 AMOUNT',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'scheduleb_1_8_text',
                text: 'scheduleb_1_8_text',
                line: 'Line 8 TEXT',
                type: 'string',
                inputType: 'text',
                defaultValue: '',
            },
            {
                name: 'scheduleb_1_8_amount',
                text: 'scheduleb_1_8_amount',
                line: 'Line 8 AMOUNT',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'scheduleb_1_9_text',
                text: 'scheduleb_1_9_text',
                line: 'Line 9 TEXT',
                type: 'string',
                inputType: 'text',
                defaultValue: '',
            },
            {
                name: 'scheduleb_1_9_amount',
                text: 'scheduleb_1_9_amount',
                line: 'Line 9 AMOUNT',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'scheduleb_1_10_text',
                text: 'scheduleb_1_10_text',
                line: 'Line 10 TEXT',
                type: 'string',
                inputType: 'text',
                defaultValue: '',
            },
            {
                name: 'scheduleb_1_10_amount',
                text: 'scheduleb_1_10_amount',
                line: 'Line 10 AMOUNT',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'scheduleb_1_11_text',
                text: 'scheduleb_1_11_text',
                line: 'Line 11 TEXT',
                type: 'string',
                inputType: 'text',
                defaultValue: '',
            },
            {
                name: 'scheduleb_1_11_amount',
                text: 'scheduleb_1_11_amount',
                line: 'Line 11 AMOUNT',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'scheduleb_1_12_text',
                text: 'scheduleb_1_12_text',
                line: 'Line 12 TEXT',
                type: 'string',
                inputType: 'text',
                defaultValue: '',
            },
            {
                name: 'scheduleb_1_12_amount',
                text: 'scheduleb_1_12_amount',
                line: 'Line 12 AMOUNT',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'scheduleb_1_13_text',
                text: 'scheduleb_1_13_text',
                line: 'Line 13 TEXT',
                type: 'string',
                inputType: 'text',
                defaultValue: '',
            },
            {
                name: 'scheduleb_1_13_amount',
                text: 'scheduleb_1_13_amount',
                line: 'Line 13 AMOUNT',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'scheduleb_1_14_text',
                text: 'scheduleb_1_14_text',
                line: 'Line 14 TEXT',
                type: 'string',
                inputType: 'text',
                defaultValue: '',
            },
            {
                name: 'scheduleb_1_14_amount',
                text: 'scheduleb_1_14_amount',
                line: 'Line 14 AMOUNT',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'scheduleb_1_15_text',
                text: 'scheduleb_1_15_text',
                line: 'Line 15 TEXT',
                type: 'string',
                inputType: 'text',
                defaultValue: '',
            },
            {
                name: 'scheduleb_1_15_amount',
                text: 'scheduleb_1_15_amount',
                line: 'Line 15 AMOUNT',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'scheduleb_2',
                text: 'Add the amounts on line 1',
                line: 'Line 2',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'scheduleb_3',
                text: 'Attach from 8815',
                line: 'Line 3',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'scheduleb_4',
                text: 'Substract line 3 from line 2',
                line: 'Line 4 AMOUNT',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
        ],
    },
    {
        section: 'Schedule B Part 2',
        fields: [
            // line 5
            {
                name: 'scheduleb_5_0_text',
                text: 'scheduleb_5_0_text',
                line: 'Line 0 TEXT',
                type: 'string',
                inputType: 'text',
                defaultValue: '',
            },
            {
                name: 'scheduleb_5_0_amount',
                text: 'scheduleb_5_0_amount',
                line: 'Line 0 AMOUNT',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'scheduleb_5_1_text',
                text: 'scheduleb_5_1_text',
                line: 'Line 1 TEXT',
                type: 'string',
                inputType: 'text',
                defaultValue: '',
            },
            {
                name: 'scheduleb_5_1_amount',
                text: 'scheduleb_5_1_amount',
                line: 'Line 1 AMOUNT',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'scheduleb_5_2_text',
                text: 'scheduleb_5_2_text',
                line: 'Line 2 TEXT',
                type: 'string',
                inputType: 'text',
                defaultValue: '',
            },
            {
                name: 'scheduleb_5_2_amount',
                text: 'scheduleb_5_2_amount',
                line: 'Line 2 AMOUNT',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'scheduleb_5_3_text',
                text: 'scheduleb_5_3_text',
                line: 'Line 3 TEXT',
                type: 'string',
                inputType: 'text',
                defaultValue: '',
            },
            {
                name: 'scheduleb_5_3_amount',
                text: 'scheduleb_5_3_amount',
                line: 'Line 3 AMOUNT',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'scheduleb_5_4_text',
                text: 'scheduleb_5_4_text',
                line: 'Line 4 TEXT',
                type: 'string',
                inputType: 'text',
                defaultValue: '',
            },
            {
                name: 'scheduleb_5_4_amount',
                text: 'scheduleb_5_4_amount',
                line: 'Line 4 AMOUNT',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'scheduleb_5_5_text',
                text: 'scheduleb_5_5_text',
                line: 'Line 5 TEXT',
                type: 'string',
                inputType: 'text',
                defaultValue: '',
            },
            {
                name: 'scheduleb_5_5_amount',
                text: 'scheduleb_5_5_amount',
                line: 'Line 5 AMOUNT',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'scheduleb_5_6_text',
                text: 'scheduleb_5_6_text',
                line: 'Line 6 TEXT',
                type: 'string',
                inputType: 'text',
                defaultValue: '',
            },
            {
                name: 'scheduleb_5_6_amount',
                text: 'scheduleb_5_6_amount',
                line: 'Line 6 AMOUNT',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'scheduleb_5_7_text',
                text: 'scheduleb_5_7_text',
                line: 'Line 7 TEXT',
                type: 'string',
                inputType: 'text',
                defaultValue: '',
            },
            {
                name: 'scheduleb_5_7_amount',
                text: 'scheduleb_5_7_amount',
                line: 'Line 7 AMOUNT',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'scheduleb_5_8_text',
                text: 'scheduleb_5_8_text',
                line: 'Line 8 TEXT',
                type: 'string',
                inputType: 'text',
                defaultValue: '',
            },
            {
                name: 'scheduleb_5_8_amount',
                text: 'scheduleb_5_8_amount',
                line: 'Line 8 AMOUNT',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'scheduleb_5_9_text',
                text: 'scheduleb_5_9_text',
                line: 'Line 9 TEXT',
                type: 'string',
                inputType: 'text',
                defaultValue: '',
            },
            {
                name: 'scheduleb_5_9_amount',
                text: 'scheduleb_5_9_amount',
                line: 'Line 9 AMOUNT',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'scheduleb_5_10_text',
                text: 'scheduleb_5_10_text',
                line: 'Line 10 TEXT',
                type: 'string',
                inputType: 'text',
                defaultValue: '',
            },
            {
                name: 'scheduleb_5_10_amount',
                text: 'scheduleb_5_10_amount',
                line: 'Line 10 AMOUNT',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'scheduleb_5_11_text',
                text: 'scheduleb_5_11_text',
                line: 'Line 11 TEXT',
                type: 'string',
                inputType: 'text',
                defaultValue: '',
            },
            {
                name: 'scheduleb_5_11_amount',
                text: 'scheduleb_5_11_amount',
                line: 'Line 11 AMOUNT',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'scheduleb_5_12_text',
                text: 'scheduleb_5_12_text',
                line: 'Line 12 TEXT',
                type: 'string',
                inputType: 'text',
                defaultValue: '',
            },
            {
                name: 'scheduleb_5_12_amount',
                text: 'scheduleb_5_12_amount',
                line: 'Line 12 AMOUNT',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'scheduleb_5_13_text',
                text: 'scheduleb_5_13_text',
                line: 'Line 13 TEXT',
                type: 'string',
                inputType: 'text',
                defaultValue: '',
            },
            {
                name: 'scheduleb_5_13_amount',
                text: 'scheduleb_5_13_amount',
                line: 'Line 13 AMOUNT',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'scheduleb_5_14_text',
                text: 'scheduleb_5_14_text',
                line: 'Line 14 TEXT',
                type: 'string',
                inputType: 'text',
                defaultValue: '',
            },
            {
                name: 'scheduleb_5_14_amount',
                text: 'scheduleb_5_14_amount',
                line: 'Line 14 AMOUNT',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'scheduleb_5_15_text',
                text: 'scheduleb_5_15_text',
                line: 'Line 15 TEXT',
                type: 'string',
                inputType: 'text',
                defaultValue: '',
            },
            {
                name: 'scheduleb_5_15_amount',
                text: 'scheduleb_5_15_amount',
                line: 'Line 15 AMOUNT',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'scheduleb_6',
                text: 'Add the amounts on line 5',
                line: 'Line 6 AMOUNT',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
        ],
    },
    {
        section: 'Schedule C',
        fields: [
            {
                name: 'clientHasScheduleC',
                text: 'Has Schedule C?',
                type: 'string',
                options: ['Yes', 'No'],
                inputType: 'radiobutton',
                defaultValue: 'No',
            },
            {
                name: 'grossReceipts',
                text: 'Gross receipts or sales',
                line: 'Line 1',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'returns',
                text: 'Returns and allowances',
                line: 'Line 2',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                //name: 'line3Sch',
                name: 'line3SchC',
                text: 'Substract line 2 from line 1',
                line: 'Line 3',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'costOfGoods',
                text: 'Cost of goods sold',
                line: 'Line 4',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'grossProfit',
                text: 'Gross Profit',
                line: 'Line 5',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'otherIncomeSchC',
                text: 'Other Income',
                line: 'Line 6',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'grossIncome',
                text: 'Gross Income',
                line: 'Line 7',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'advertising',
                text: 'Advertising',
                line: 'Line 8',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'carExpenses',
                text: 'Car and truck expenses',
                line: 'Line 9',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'commissions',
                text: 'Commissions and fees',
                line: 'Line 10',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'contractLabor',
                text: 'Contract Labor',
                line: 'Line 11',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'depletion',
                text: 'Depletion',
                line: 'Line 12',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'depreciation',
                text: 'Depreciation',
                line: 'Line 13',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'employeeBenefit',
                text: 'Employee Benefit programs',
                line: 'Line 14',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'insurance',
                text: 'Insurance (other than health)',
                line: 'Line 15',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'interestMortgage',
                text: 'Interest Mortgage',
                line: 'Line 16a',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'interestOther',
                text: 'Interest Other',
                line: 'Line 16b',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'legal',
                text: 'Legal and professional services',
                line: 'Line 17',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'officeExpenses',
                text: 'Office Expenses',
                line: 'Line 18',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'pensionPlans',
                text: 'Pension and profit-sharing plans',
                line: 'Line 19',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'vehiclesMachinery',
                text: 'Rent or lease of vehicles, machinery, and equipment',
                line: 'Line 20a',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'otherBusinessProperty',
                text: 'Rent or lease of other business property',
                line: 'Line 20b',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'repairs',
                text: 'Repairs',
                line: 'Line 21',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'supplies',
                text: 'Supplies',
                line: 'Line 22',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'taxesAndLicenses',
                text: 'Taxes and Licenses',
                line: 'Line 23',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'travel',
                text: 'Travel',
                line: 'Line 24a',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'meals',
                text: 'Meals',
                line: 'Line 24b',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'utilities',
                text: 'Utilities',
                line: 'Line 25',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'wagesLessEmployeeCredits',
                text: 'Wages (less employment credits)',
                line: 'Line 26',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'otherExpenses_schC',
                text: 'Other Expenses',
                line: 'Line 27a',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'totalExpenses',
                text: 'Total Expenses',
                line: 'Line 28',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'tentativeProfit',
                text: 'Tentative Profit',
                line: 'Line 29',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'expensesForHomeBusinessTF',
                text: 'Expenses for business use of your home?',
                line: 'Line 30',
                type: 'string',
                options: ['Yes', 'No'],
                inputType: 'radiobutton',
                defaultValue: 'No',
            },
            {
                name: 'expensesForHomeBusiness',
                text: 'Expenses for business use of your home',
                line: 'Line 30',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'netProfitOrLoss',
                text: 'Net profit or (loss) from business',
                line: 'Line 31',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
        ],
    },
    {
        section: 'Schedule D',
        fields: [
            {
                name: 'clientHasScheduleD',
                text: 'Has Schedule D?',
                type: 'string',
                options: ['Yes', 'No'],
                inputType: 'radiobutton',
                defaultValue: 'No',
            },
            {
                name: 'scheduleD4',
                text: 'Short-term gain from Form 6252 and short-term gain or (loss) from Forms 4684, 6781, and 8824',
                line: 'Line 4',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'scheduleD5',
                text: 'Net short-term gain or (loss) from partnerships, S corporations, estates, and trusts from Schedule(s) K-1',
                line: 'Line 5',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'shortTermLossCarryover',
                text: 'Short term capital loss carryover',
                line: 'Line 6',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'netShortTermCapitalGains',
                text: 'Net short-term capital gain or (loss)',
                line: 'Line 7',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'scheduleD11',
                text: 'Gain from Form 4797, Part I; long-term gain from Forms 2439 and 6252; and long-term gain or (loss) from Forms 4684, 6781, and 8824',
                line: 'Line 11',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'scheduleD12',
                text: 'Net long-term gain or (loss) from partnerships, S corporations, estates, and trusts from Schedule(s) K-1',
                line: 'Line 12',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'scheduleD13',
                text: 'Capital gain distributions',
                line: 'Line 13',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'longTermLossCarryover',
                text: 'Long term capital loss carryover',
                line: 'Line 14',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'netLongTermCapitalGains',
                text: 'Net long-term capital gain (or loss)',
                line: 'Line 15',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'scheduleD16',
                text: 'Combine lines 7 and 15',
                line: 'Line 16',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'scheduleD18',
                text: 'If you are required to complete the 28% Rate Gain Worksheet (see instructions), enter the amount, if any, from line 7 of that worksheet',
                line: 'Line 18',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'scheduleD19',
                text: 'If you are required to complete the Unrecaptured Section 1250 Gain Worksheet (see instructions), enter the amount, if any, from line 18 of that worksheet',
                line: 'Line 19',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'scheduleD21',
                text: 'If line 16 is a loss, enter the loss on line 16; or ($3,000), or if married filing separately, ($1,500)',
                line: 'Line 21',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
        ],
    },
    {
        section: 'Schedule E',
        fields: [
            {
                name: 'clientHasScheduleE',
                text: 'Has Schedule E?',
                type: 'string',
                options: ['Yes', 'No'],
                inputType: 'radiobutton',
                defaultValue: 'No',
            },
            {
                name: 'totalAmounts23a',
                text: 'Total amounts reported on line 3 for all rental properties',
                line: 'Line 23a',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'totalAmounts23b',
                text: 'Total amounts reported on line 4 for all royalty properties',
                line: 'Line 23b',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'totalAmounts23c',
                text: 'Total amounts reported on line 12 for all properties',
                line: 'Line 23c',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'totalAmounts23d',
                text: 'Total amounts reported on line 18 for all properties',
                line: 'Line 23d',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'totalAmounts23e',
                text: 'Total amounts reported on line 20 for all properties',
                line: 'Line 23e',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'incomeSchE',
                text: 'Income',
                line: 'Line 24',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'lossesSchE',
                text: 'Losses',
                line: 'Line 25',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'totalRentalRealEstate',
                text: 'Total rental real estate and royalty income or loss',
                line: 'Line 26',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'line30schE',
                text: 'Add columns (h) and (k)',
                line: 'Line 30',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'line31schE',
                text: 'Add columns (g), (i) and (j)',
                line: 'Line 31',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'line32schE',
                text: 'Total partnership and S corporation income or loss',
                line: 'Line 32',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'line35schE',
                text: ' Add columns (d) and (f)',
                line: 'Line 35',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'line36schE',
                text: 'Add columns (c) and (e)',
                line: 'Line 36',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'line37schE',
                text: 'Total estate and trust income or loss',
                line: 'Line 37',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'line39schE',
                text: 'Combine columns (d) and (e)',
                line: 'Line 39',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'line40schE',
                text: 'Net farm rental income or loss',
                line: 'Line 40',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'line41schE',
                text: 'Total income or loss',
                line: 'Line 41',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
        ],
    },
    {
        section: 'Schedule SE',
        fields: [
            {
                name: 'clientHasScheduleSE',
                text: 'Has Schedule SE?',
                type: 'string',
                options: ['Yes', 'No'],
                inputType: 'radiobutton',
                defaultValue: 'No',
            },
            {
                name: 'netFarmProfitOrLoss',
                text: 'Net farm profit or (loss) from Schedule F',
                line: 'Line 1a',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'conservationReserveProgramPayments',
                text: 'Amount of Conservation Reserve Program payments included on Schedule F',
                line: 'Line 1b',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'netProfitOrLossFromSchC',
                text: 'Net profit or (loss) from Schedule C, line 31',
                line: 'Line 2',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'combinelines1a1b2',
                text: 'Combine lines 1a, 1b, and 2',
                line: 'Line 3',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'line4aSchSE',
                text: 'If line 3 is more than zero, multiply line 3 by 92.35% (0.9235). Otherwise, enter amount from line 3',
                line: 'Line 4a',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'line4bSchSE',
                text: 'If you elect one or both of the optional methods, enter the total of lines 15 and 17',
                line: 'Line 4b',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'line4cSchSE',
                text: 'Combine lines 4a and 4b',
                line: 'Line 4c',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'churchEmployeeIncome',
                text: 'Enter your church employee income from Form W-2',
                line: 'Line 5a',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'line5bSchSE',
                text: 'Multiply line 5a by 92.35%',
                line: 'Line 5b',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'addLines4c5b',
                text: 'Add lines 4c and 5b',
                line: 'Line 6',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'maximumAmountofCombinedWages',
                text: 'Maximum amount of combined wages and self-employment earnings subject to social security tax',
                line: 'Line 7',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'totalSocialSecurityWages',
                text: 'Total social security wages and tips',
                line: 'Line 8a',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'unreportedTips',
                text: 'Unreported tips subject to social security tax',
                line: 'Line 8b',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'wagesSubjectToSocialSecurity',
                text: 'Wages subject to social security tax from Form 8919, line 10',
                line: 'Line 8c',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'add8a8b8c',
                text: 'Add lines 8a, 8b, and 8c',
                line: 'Line 8d',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'line9SchSE',
                text: 'Subtract line 8d from line 7',
                line: 'Line 9',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'line10SchSE',
                text: 'Multiply the smaller of line 6 or line 9 by 12.4%',
                line: 'Line 10',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'line11SchSE',
                text: 'Multiply line 6 by 2.9%',
                line: 'Line 11',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'selfEmploymentTax',
                text: 'Self-employment tax',
                line: 'Line 12',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'deductionForOneHalfOfSelfemployment',
                text: 'Deduction for one-half of self-employment tax',
                line: 'Line 13',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
        ],
    },
    {
        section: 'Form 709',
        fields: [
            {
                name: 'clientHasForm709',
                text: 'Has Form 709?',
                type: 'string',
                options: ['Yes', 'No'],
                inputType: 'radiobutton',
                defaultValue: 'No',
            },
            {
                name: 'totalGiftsScheduleAPart4',
                text: 'Enter the amount from Schedule A, Part 4, line 11',
                line: 'Line 1',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'priorPeriodTaxableGiftsScheduleB',
                text: 'Enter the amount from Schedule B, line 3',
                line: 'Line 2',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'totalTaxableGifts',
                text: 'Total taxable gifts. Add lines 1 and 2',
                line: 'Line 3',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'giftTaxOnTotalTaxableGifts',
                text: 'Tax computed on amount on line 3',
                line: 'Line 4',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'giftTaxOnPriorPeriodGifts',
                text: 'Tax computed on amount on line 2',
                line: 'Line 5',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'giftTaxBalance',
                text: 'Balance. Subtract line 5 from line 4',
                line: 'Line 6',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'applicableCreditAmount',
                text: 'Applicable credit amount',
                line: 'Line 7',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'priorPeriodApplicableCredit',
                text: 'Enter the applicable credit against tax allowable for all prior periods from Schedule B, line 1, col. (c)',
                line: 'Line 8',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'remainingApplicableCredit',
                text: 'Balance. Subtract line 8 from line 7. Do not enter less than zero',
                line: 'Line 9',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'specificExemptionCredit',
                text: 'Enter 20% (0.20) of the amount allowed as a specific exemption for gifts...',
                line: 'Line 10',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'netApplicableCredit',
                text: 'Balance. Subtract line 10 from line 9. Do not enter less than zero',
                line: 'Line 11',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'creditAppliedAgainstTax',
                text: 'Applicable credit. Enter the smaller of line 6 or line 11',
                line: 'Line 12',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'foreignGiftTaxCredit',
                text: 'Credit for foreign gift taxes',
                line: 'Line 13',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'totalCredits',
                text: 'Total credits. Add lines 12 and 13',
                line: 'Line 14',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'netGiftTax',
                text: 'Balance. Subtract line 14 from line 6. Do not enter less than zero',
                line: 'Line 15',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'generationSkippingTransferTax',
                text: 'Generation-skipping transfer taxes from Schedule D, Part 3, col. (g), total',
                line: 'Line 16',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'totalGiftAndGstTax',
                text: 'Total tax. Add lines 15 and 16',
                line: 'Line 17',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'taxPrepaidWithExtension',
                text: 'Gift and generation-skipping transfer taxes prepaid with extension of time to file',
                line: 'Line 18',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'taxDue',
                text: 'Tax due',
                line: 'Line 19',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: '',
                text: '',
                line: 'Line 20',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'overpaymentAmount',
                text: 'Overpayment',
                line: 'Line 20a',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
        ],
    },
    {
        section: 'Form 6251',
        fields: [
            {
                name: 'clientHasForm6251',
                text: 'Has Form 6251?',
                type: 'string',
                options: ['Yes', 'No'],
                inputType: 'radiobutton',
                defaultValue: 'No',
            },
            {
                name: 'adjustedLine14',
                text: 'Subtract Schedule 1-A (Form 1040), line 37, from Form 1040, 1040-SR, or 1040-NR, line 14',
                line: 'Line 1a',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'adjustedLine11b',
                text: 'Subtract line 1a from Form 1040, 1040-SR, or 1040-NR, line 11b',
                line: 'Line 1b',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'itemizedOrStandardTaxes',
                text: 'If filing Schedule A (Form 1040), enter the taxes from Schedule A, line 7',
                line: 'Line 2a',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'taxRefundAdjustment',
                text: 'Tax refund from Schedule 1 (Form 1040), line 1 or line 8z',
                line: 'Line 2b',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'investmentInterestAdj',
                text: 'Investment interest expense (difference between regular tax and AMT)',
                line: 'Line 2c',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'depletionAdj',
                text: 'Depletion (difference between regular tax and AMT)',
                line: 'Line 2d',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'netOperatingLossDeduction',
                text: 'Net operating loss deduction from Schedule 1 (Form 1040), line 8a',
                line: 'Line 2e',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'altMinTaxNOLDeduction',
                text: 'Alternative tax net operating loss deduction',
                line: 'Line 2f',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'privateActivityBondInterest',
                text: 'Interest from specified private activity bonds exempt from the regular tax',
                line: 'Line 2g',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'qsbsAdjustment',
                text: 'Qualified small business stock, see instructions',
                line: 'Line 2h',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'isoExerciseAdjustment',
                text: 'Exercise of incentive stock options (excess of AMT income over regular tax income)',
                line: 'Line 2i',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'estateTrustIncomeAdj',
                text: 'Estates and trusts (amount from Schedule K-1 (Form 1041), box 12, code A)',
                line: 'Line 2j',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'propertyDispositionAdj',
                text: 'Disposition of property (difference between AMT and regular tax gain or loss)',
                line: 'Line 2k',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'amtDepreciationAdj',
                text: 'Depreciation on assets placed in service after 1986 (difference between regular tax and AMT)',
                line: 'Line 2l',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'passiveActivityAdj',
                text: 'Passive activities (difference between AMT and regular tax income or loss)',
                line: 'Line 2m',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'lossLimitationAdj',
                text: 'Loss limitations (difference between AMT and regular tax income or loss)',
                line: 'Line 2n',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'circulationCostAdj',
                text: 'Circulation costs (difference between regular tax and AMT)',
                line: 'Line 2o',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'longTermContractAdj',
                text: 'Long-term contracts (difference between AMT and regular tax income)',
                line: 'Line 2p',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'miningCostAdj',
                text: 'Mining costs (difference between regular tax and AMT)',
                line: 'Line 2q',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'researchExpenseAdj',
                text: 'Research and experimental costs (difference between regular tax and AMT)',
                line: 'Line 2r',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'pre1987InstallmentIncome',
                text: 'Income from certain installment sales before January 1, 1987',
                line: 'Line 2s',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'intangibleDrillingCostPref',
                text: 'Intangible drilling costs preference',
                line: 'Line 2t',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'otherAmtAdjustments',
                text: 'Other adjustments, including income-based related adjustments',
                line: 'Line 3',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'alternativeMinimumTaxableIncome',
                text: 'Alternative minimum taxable income',
                line: 'Line 4',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'amtExemption',
                text: 'Exemption',
                line: 'Line 5',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'amtTaxableExcess',
                text: 'Subtract line 5 from line 4',
                line: 'Line 6',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'tentativeAmtBase',
                text: 'If you are filing Form 2555, see instructions for the amount to enter.',
                line: 'Line 7',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'amtForeignTaxCredit',
                text: 'Alternative minimum tax foreign tax credit',
                line: 'Line 8',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'tentativeMinimumTax',
                text: 'Tentative minimum tax. Subtract line 8 from line 7',
                line: 'Line 9',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'regularTaxAdjusted',
                text: 'Add Form 1040 or 1040-SR, line 16 (minus any tax from Form 4972)...',
                line: 'Line 10',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'alternativeMinimumTax',
                text: 'AMT. Subtract line 10 from line 9. If zero or less, enter -0-',
                line: 'Line 11',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'amtTaxableIncome',
                text: 'Enter the amount from Form 6251, line 6',
                line: 'Line 12',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'amtQualifiedDivCapitalGain',
                text: 'Enter the amount from line 4 of the Qualified Dividends and Capital Gain Tax Worksheet...',
                line: 'Line 13',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'amtScheduleDCapitalGain',
                text: 'Enter the amount from Schedule D (Form 1040), line 19 (as refigured for the AMT, if necessary)',
                line: 'Line 14',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'amtCapitalGainLimit',
                text: 'If you did not complete a Schedule D Tax Worksheet for the regular tax or the AMT...',
                line: 'Line 15',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'amtOrdinaryIncomePortion',
                text: 'Enter the smaller of line 12 or line 15',
                line: 'Line 16',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'amtOrdinaryIncomeExcess',
                text: 'Subtract line 16 from line 12',
                line: 'Line 17',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'amtOrdinaryTax',
                text: 'If line 17 is $239,100 or less ($119,550 or less if married filing separately)...',
                line: 'Line 18',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'zeroRateThreshold',
                text: 'Enter: $96,700 if married filing jointly or qualifying surviving spouse...',
                line: 'Line 19',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'regularTaxCapitalGainBase',
                text: 'Enter the amount from line 5 of the Qualified Dividends and Capital Gain Tax Worksheet...',
                line: 'Line 20',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'zeroRateExcess',
                text: 'Subtract line 20 from line 19. If zero or less, enter -0-',
                line: 'Line 21',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'amtCapitalGainBase',
                text: 'Enter the smaller of line 12 or line 13',
                line: 'Line 22',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'zeroRateTaxedAmount',
                text: 'Enter the smaller of line 21 or line 22',
                line: 'Line 23',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'capitalGainRemainder',
                text: 'Subtract line 23 from line 22',
                line: 'Line 24',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'fifteenPercentThreshold',
                text: 'Enter: $533,400 if single...',
                line: 'Line 25',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'zeroRateCarryover',
                text: 'Enter the amount from line 21',
                line: 'Line 26',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'regularCapitalGainBase',
                text: 'Enter the amount from line 5 of the Qualified Dividends and Capital Gain Tax Worksheet...',
                line: 'Line 27',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'capitalGainBaseSum',
                text: 'Add line 26 and line 27',
                line: 'Line 28',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'fifteenRateExcess',
                text: 'Subtract line 28 from line 25. If zero or less, enter -0-',
                line: 'Line 29',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'fifteenRateTaxedAmount',
                text: 'Enter the smaller of line 24 or line 29',
                line: 'Line 30',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'fifteenPercentTax',
                text: 'Multiply line 30 by 15% (0.15)',
                line: 'Line 31',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'zeroAndFifteenSum',
                text: 'Add lines 23 and 30',
                line: 'Line 32',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'twentyRateBase',
                text: 'Subtract line 32 from line 22',
                line: 'Line 33',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'twentyPercentTax',
                text: 'Multiply line 33 by 20% (0.20)',
                line: 'Line 34',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'postThresholdIncomeSum',
                text: 'Add lines 17, 32, and 33',
                line: 'Line 35',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'highRateExcess',
                text: 'Subtract line 35 from line 12',
                line: 'Line 36',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'twentyFivePercentTax',
                text: 'Multiply line 36 by 25% (0.25)',
                line: 'Line 37',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'totalAmtBeforeLimit',
                text: 'Add lines 18, 31, 34, and 37',
                line: 'Line 38',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'amtFlatTax',
                text: 'If line 12 is $239,100 or less ($119,550 or less if married filing separately)...',
                line: 'Line 39',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'tentativeAmt',
                text: 'Enter the smaller of line 38 or line 39 here and on line 7',
                line: 'Line 40',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
        ],
    },
    {
        section: 'Form 8582',
        fields: [
            {
                name: 'clientHasForm8582',
                text: 'Has Form 8582?',
                type: 'string',
                options: ['Yes', 'No'],
                inputType: 'radiobutton',
                defaultValue: 'No',
            },
            {
                name: 'form8582SectionOne1a',
                text: 'Activities with net income',
                line: 'Line 1a',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'form8582SectionOne1b',
                text: 'Activities with net loss',
                line: 'Line 1b',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'form8582SectionOne1c',
                text: 'Prior years unallowed losses',
                line: 'Line 1c',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'form8582SectionOne1d',
                text: 'Combine lines 1a, 1b, and 1c',
                line: 'Line 1d',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'form8582SectionOne2a',
                text: 'Activities with net income',
                line: 'Line 2a',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'form8582SectionOne2b',
                text: 'Activities with net loss',
                line: 'Line 2b',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'form8582SectionOne2c',
                text: 'Prior years unallowed losses',
                line: 'Line 2c',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'form8582SectionOne2d',
                text: 'Combine lines 2a, 2b, and 2c',
                line: 'Line 2d',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'form8582SectionOne3',
                text: 'Combine lines 1d and 2d',
                line: 'Line 3',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'form8582SectionTwo4',
                text: 'Enter the smaller of the loss on line 1d or the loss on line 3',
                line: 'Line 4',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'form8582SectionTwo8',
                text: 'Home mortgage interes not reported to you on Form 1098',
                line: 'Line 8',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'form8582SectionTwo9',
                text: 'Enter the smaller of line 4 or line 8',
                line: 'Line 9',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'form8582SectionThree11',
                text: 'Total losses allowed from all passive activities',
                line: 'Line 11',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'form8582SectionSevena',
                text: '(a) Loss',
                line: 'Line 7a',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'form8582SectionSevenc',
                text: '(c) Unallowed loss',
                line: 'Line 7c',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'form8582SectionEighta',
                text: '(a) Loss',
                line: 'Line 8a',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'form8582SectionEightb',
                text: '(b) Unallowed loss',
                line: 'Line 8b',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'form8582SectionEightc',
                text: '(c) Allowed loss',
                line: 'Line 8c',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
        ],
    },
    {
        section: 'Form 8812',
        fields: [
            {
                name: 'clientHasSchedule8812',
                text: 'Does the client has Form 8812?',
                type: 'string',
                options: ['Yes', 'No'],
                inputType: 'radiobutton',
                defaultValue: 'No',
            },
            {
                name: 'schedule88121',
                text: 'Enter the amount from line 11 of your Form 1040, 1040-SR, or 1040-NR',
                line: 'Line 1',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'schedule88122a',
                text: 'Enter income from Puerto Rico that you excluded',
                line: 'Line 2a',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'schedule88122b',
                text: 'Enter the amounts from lines 45 and 50 of your Form 2555',
                line: 'Line 2b',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'schedule88122c',
                text: 'Enter the amount from line 15 of your Form 4563',
                line: 'Line 2c',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'schedule88122d',
                text: 'Add lines 2a through 2c',
                line: 'Line 2d',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'schedule88123',
                text: 'Add lines 1 and 2d',
                line: 'Line 3',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'schedule88124',
                text: 'Number of qualifying children under age 17 with the required social security number',
                line: 'Line 4',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'schedule88125',
                text: 'Multiply line 4 by $2,000 ',
                line: 'Line 5',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'schedule88126',
                text: 'Number of other dependents, including any qualifying children who are not under age 17 or who do not have the required social security number',
                line: 'Line 6',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'schedule88127',
                text: 'Multiply line 6 by $500',
                line: 'Line7',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'schedule88128',
                text: 'Add lines 5 and 7',
                line: 'Line 8',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'schedule88129',
                text: 'Enter the amount shown below for your filing status. • Married filing jointly—$400,000 • All other filing statuses—$200,000',
                line: 'Line 9',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'schedule881210',
                text: 'Subtract line 9 from line 3',
                line: 'Line 10',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'schedule881211',
                text: 'Multiply line 10 by 5% (0.05)',
                line: 'Line 11',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'schedule881212',
                text: 'Is the amount on line 8 more than the amount on line 11?',
                line: 'Line 12',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'schedule881213',
                text: 'Enter the amount from Credit Limit Worksheet A',
                line: 'Line 13',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'schedule881214',
                text: 'Enter the smaller of line 12 or line 13.',
                line: 'Line 14',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'schedule881216a',
                text: 'Subtract line 14 from line 12',
                line: 'Line 16a',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'schedule881216b',
                text: 'Number of qualifying children under age 17 with the required social security number',
                line: 'Line 16b',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'schedule881217',
                text: 'Enter the smaller of line 16a or line 16b',
                line: 'Line 17',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'schedule881218a',
                text: 'Earned income',
                line: 'Line 18a',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'schedule881219',
                text: 'If the amount on line 18a more than $2,500, Subtract $2,500 from the amount on line 18a. ',
                line: 'Line 19',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'schedule881220',
                text: 'Multiply the amount on line 19 by 15% (0.15) and enter the result',
                line: 'Line 20',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'schedule881221',
                text: 'Withheld social security, Medicare, and Additional Medicare taxes from Form(s) W-2, boxes 4 and 6',
                line: 'Line 21',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'schedule881222',
                text: 'Enter the total of the amounts from Schedule 1 (Form 1040), line 15; Schedule 2 (Form 1040), line 5; Schedule 2 (Form 1040), line 6; and Schedule 2 (Form 1040), line 13',
                line: 'Line 22',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'schedule881223',
                text: 'Add lines 21 and 22',
                line: 'Line 23',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'schedule881224',
                text: 'Enter the total of the amounts from Form 1040 or 1040-SR, line 27, and Schedule 3 (Form 1040), line 11',
                line: 'Line 24',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'schedule881225',
                text: 'Subtract line 24 from line 23. If zero or less, enter -0-',
                line: 'Line 25',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'schedule881226',
                text: 'Enter the larger of line 20 or line 25',
                line: 'Line 26',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'schedule881227',
                text: 'This is your additional child tax credit. Enter this amount on Form 1040, 1040-SR, or 1040-NR, line 28',
                line: 'Line 27',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
        ],
    },
    {
        section: 'Form 8889',
        fields: [
            {
                name: 'clientHasForm8889',
                text: 'Does the client has Form 8889?',
                type: 'string',
                options: ['Yes', 'No'],
                inputType: 'radiobutton',
                defaultValue: 'No',
            },
            {
                name: 'hsaLastYearContribution',
                text: 'HSA contributions you made for 2025 (or those made on your behalf)...',
                line: 'Line 2',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'eligibleIndividualAmount',
                text: 'If you were under age 55 at the end of 2025 and, on the first day of every month during 2025...',
                line: 'Line 3',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'archerMsaContributions',
                text: 'Enter the amount you and your employer contributed to your Archer MSAs for 2025...',
                line: 'Line 4',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'msaContributionExcess',
                text: 'Subtract line 4 from line 3. If zero or less, enter -0-',
                line: 'Line 5',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'adjustedHsaContribution',
                text: 'Enter the amount from line 5',
                line: 'Line 6',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'additionalHsaContribution55Plus',
                text: 'If you were age 55 or older at the end of 2025, married, and you or your spouse had family coverage...',
                line: 'Line 7',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'totalHsaContribution',
                text: 'Add lines 6 and 7',
                line: 'Line 8',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'employerHsaContributions',
                text: 'Employer contributions made to your HSAs for 2025',
                line: 'Line 9',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'qualifiedHsaFundingDist',
                text: 'Qualified HSA funding distributions',
                line: 'Line 10',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'totalHsaFunding',
                text: 'Add lines 9 and 10',
                line: 'Line 11',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'hsaDeductionAmount',
                text: 'Subtract line 11 from line 8. If zero or less, enter -0-',
                line: 'Line 12',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'hsaDeduction',
                text: 'HSA deduction',
                line: 'Line 13',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'hsaDistributionsTotal',
                text: 'Total distributions you received in 2025 from all HSAs',
                line: 'Line 14a',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'hsaDistributionsRolledOver',
                text: 'Distributions included on line 14a that you rolled over to another HSA',
                line: 'Line 14b',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'hsaDistributionsNet',
                text: 'Subtract line 14b from line 14a',
                line: 'Line 14c',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'qualifiedMedicalExpenses',
                text: 'Qualified medical expenses paid using HSA distributions',
                line: 'Line 15',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'taxableHsaDistributions',
                text: 'Taxable HSA distributions',
                line: 'Line 16',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'hsaAdditional20PctTax',
                text: 'Additional 20% tax',
                line: 'Line 17b',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'hdhpLastMonthRule',
                text: 'Last-month rule',
                line: 'Line 18',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'qualifiedHsaFundingDistIncome',
                text: 'Qualified HSA funding distribution',
                line: 'Line 19',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'totalHsaIncome',
                text: 'Total income',
                line: 'Line 20',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'additionalHsaTax10Pct',
                text: 'Additional tax',
                line: 'Line 21',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
        ],
    },

    {
        section: 'Form 8959',
        fields: [
            {
                name: 'clientHasForm8959',
                text: 'Has Form 8995?',
                type: 'string',
                options: ['Yes', 'No'],
                inputType: 'radiobutton',
                defaultValue: 'No',
            },
            {
                name: 'medicareWagesTips',
                text: 'Medicare wages and tips from Form W-2, box 5',
                line: 'Line 1',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'unreportedTips8959',
                text: 'Unreported tips from Form 4137, line 6',
                line: 'Line 2',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'form8919Wages',
                text: 'Wages from Form 8919, line 6',
                line: 'Line 3',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'totalMedicareWages',
                text: 'Add lines 1 through 3',
                line: 'Line 4',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'medicareThreshold',
                text: 'Enter the following amount for your filing status',
                line: 'Line 5',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'excessMedicareWages',
                text: 'Subtract line 5 from line 4. If zero or less, enter -0-',
                line: 'Line 6',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'additionalMedicareTaxWages',
                text: 'Additional Medicare Tax on Medicare wages',
                line: 'Line 7',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'selfEmploymentIncome',
                text: 'Self-employment income from Schedule SE (Form 1040)...',
                line: 'Line 8',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'selfEmploymentThreshold',
                text: 'Enter the following amount for your filing status',
                line: 'Line 9',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'medicareWagesFromPartI',
                text: 'Enter the amount from line 4',
                line: 'Line 10',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'excessSelfEmployment',
                text: 'Subtract line 10 from line 9. If zero or less, enter -0-',
                line: 'Line 11',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'adjustedSelfEmploymentIncome',
                text: 'Subtract line 11 from line 8. If zero or less, enter -0-',
                line: 'Line 12',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'additionalMedicareTaxSelfEmployment',
                text: 'Additional Medicare Tax on self-employment income',
                line: 'Line 13',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'rrtaCompensation',
                text: 'Railroad retirement (RRTA) compensation and tips from Form(s) W-2, box 14',
                line: 'Line 14',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'rrtaThreshold',
                text: 'Enter the following amount for your filing status',
                line: 'Line 15',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'excessRrtaCompensation',
                text: 'Subtract line 15 from line 14. If zero or less, enter -0-',
                line: 'Line 16',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'additionalMedicareTaxRrta',
                text: 'Additional Medicare Tax on railroad retirement (RRTA) compensation',
                line: 'Line 17',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'totalAdditionalMedicareTax',
                text: 'Add lines 7, 13, and 17',
                line: 'Line 18',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'medicareTaxWithheld',
                text: 'Medicare tax withheld from Form W-2, box 6',
                line: 'Line 19',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'medicareWagesForRegularTax',
                text: 'Enter the amount from line 1',
                line: 'Line 20',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'regularMedicareTaxWithholding',
                text: 'Multiply line 20 by 1.45% (0.0145)',
                line: 'Line 21',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'additionalMedicareTaxWithholding',
                text: 'Subtract line 21 from line 19',
                line: 'Line 22',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'rrtaAdditionalMedicareTaxWithholding',
                text: 'Additional Medicare Tax withholding on railroad retirement (RRTA) compensation...',
                line: 'Line 23',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'totalAdditionalMedicareTaxWithholding',
                text: 'Total Additional Medicare Tax withholding',
                line: 'Line 24',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
        ],
    },
    {
        section: 'Form 8960',
        fields: [
            {
                name: 'clientHasForm8960',
                text: 'Has Form 8960?',
                type: 'string',
                options: ['Yes', 'No'],
                inputType: 'radiobutton',
                defaultValue: 'No',
            },
            {
                name: 'taxableInterest',
                text: 'Taxable interest',
                line: 'Line 1',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'ordinaryDividends',
                text: 'Ordinary dividends',
                line: 'Line 2',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'annuitiesIncome',
                text: 'Annuities',
                line: 'Line 3',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'rentalRoyaltiesPartnershipsSCorpTrusts',
                text: 'Rental real estate, royalties, partnerships, S corporations, trusts, trades or businesses, etc.',
                line: 'Line 4a',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'nonSection1411BusinessAdj',
                text: 'Adjustment for net income or loss derived in the ordinary course of a non- section 1411 trade or business',
                line: 'Line 4b',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'combinedBusinessIncome',
                text: 'Combine lines 4a and 4b',
                line: 'Line 4c',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'netGainDispositionProperty',
                text: 'Net gain or loss from disposition of property',
                line: 'Line 5a',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'nonNiitDisposition',
                text: 'Net gain or loss from disposition of property that is not subject to net investment income tax',
                line: 'Line 5b',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'partnershipStockDispositionAdj',
                text: 'Adjustment from disposition of partnership interest or S corporation stock',
                line: 'Line 5c',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'totalDispositionGain',
                text: 'Combine lines 5a through 5c',
                line: 'Line 5d',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'cfcPficInvestmentAdj',
                text: 'Adjustments to investment income for certain CFCs and PFICs',
                line: 'Line 6',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'otherInvestmentModifications',
                text: 'Other modifications to investment income',
                line: 'Line 7',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'totalInvestmentIncome',
                text: 'Total investment income. Combine lines 1, 2, 3, 4c, 5d, 6, and 7',
                line: 'Line 8',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'investmentInterestExpenses',
                text: 'Investment interest expenses',
                line: 'Line 9a',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'stateLocalForeignTaxes',
                text: 'State, local, and foreign income tax',
                line: 'Line 9b',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'miscInvestmentExpenses',
                text: 'Miscellaneous investment expenses',
                line: 'Line 9c',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'totalInvestmentExpenses',
                text: 'Add lines 9a, 9b, and 9c',
                line: 'Line 9d',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'additionalInvestmentModifications',
                text: 'Additional modifications',
                line: 'Line 10',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'totalDeductionsAndModifications',
                text: 'Total deductions and modifications. Add lines 9d and 10',
                line: 'Line 11',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'netInvestmentIncome',
                text: 'Net investment income',
                line: 'Line 12',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'modifiedAdjustedGrossIncome',
                text: 'Modified adjusted gross income',
                line: 'Line 13',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'investmentIncomeThreshold',
                text: 'Threshold based on filing status',
                line: 'Line 14',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'excessIncomeOverThreshold',
                text: 'Subtract line 14 from line 13. If zero or less, enter -0-',
                line: 'Line 15',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'taxableInvestmentIncomeIndividuals',
                text: 'Enter the smaller of line 12 or line 15',
                line: 'Line 16',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'netInvestmentIncomeTaxIndividuals',
                text: 'Net investment income tax for individuals',
                line: 'Line 17',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'estateNetInvestmentIncome',
                text: 'Net investment income (line 12 above)',
                line: 'Line 18a',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'estateDistributionsAndCharitableDeductions',
                text: 'Deductions for distributions of net investment income and charitable deductions',
                line: 'Line 18b',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'undistributedNetInvestmentIncome',
                text: 'Undistributed net investment income. Subtract line 18b from line 18a',
                line: 'Line 18c',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'estateAdjustedGrossIncome',
                text: 'Adjusted gross income',
                line: 'Line 19a',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'estateBracketThreshold',
                text: 'Highest tax bracket for estates and trusts for the year',
                line: 'Line 19b',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'estateExcessIncome',
                text: 'Subtract line 19b from line 19a. If zero or less, enter -0-',
                line: 'Line 19c',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'taxableInvestmentIncomeEstates',
                text: 'Enter the smaller of line 18c or line 19c',
                line: 'Line 20',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'netInvestmentIncomeTaxEstates',
                text: 'Net investment income tax for estates and trusts',
                line: 'Line 21',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
        ],
    },
    {
        section: 'Form 8995',
        fields: [
            {
                name: 'clientHasForm8995',
                text: 'Has Form 8995?',
                type: 'string',
                options: ['Yes', 'No'],
                inputType: 'radiobutton',
                defaultValue: 'No',
            },
            {
                name: 'totalQualifiedBusinessIncome',
                text: 'Total qualified business income',
                line: 'Line 4',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'qualifiedBusinessIncomeDeduction',
                text: 'Qualified business income deduction',
                line: 'Line 15',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'totalReit',
                text: 'Total qualified REIT dividends and PTP (loss) carryforward',
                line: 'Line 17',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
        ],
    },
    {
        section: 'Form 8995-A',
        fields: [
            {
                name: 'clientHasForm8995A',
                text: 'Has Form 8995-A?',
                type: 'string',
                options: ['Yes', 'No'],
                inputType: 'radiobutton',
                defaultValue: 'No',
            },
            {
                name: 'form8995A27',
                text: 'Total qualified business income',
                line: 'Line 27',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'form8995A28',
                text: 'Qualified REIT dividends and PTP income or loss',
                line: 'Line 28',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'form8995A29',
                text: 'Qualified REIT dividends and PTP (loss) carryforward from prior years',
                line: 'Line 29',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'form8995A30',
                text: 'Total qualified REIT dividends and PTP income',
                line: 'Line 30',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'form8995A31',
                text: 'REIT and PTP component',
                line: 'Line 31',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'form8995A32',
                text: 'Qualified business income deduction before the income limitation',
                line: 'Line 32',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'form8995A33',
                text: 'Taxable income before qualified business income deduction',
                line: 'Line 33',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'form8995A34',
                text: 'Net capital gain',
                line: 'Line 34',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'form8995A35',
                text: 'Substract line 34 from line 33',
                line: 'Line 35',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'form8995A36',
                text: 'Income limitation',
                line: 'Line 36',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'form8995A37',
                text: 'Qualified business income deduction before the domestic production activities deduction DPAD under section 199A(g)',
                line: 'Line 37',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'form8995A38',
                text: 'DPAD under section 199A(g) allocated from an agricultural or horticultural cooperative',
                line: 'Line 38',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'form8995A39',
                text: 'Total qualified business income deduction',
                line: 'Line 39',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'form8995A40',
                text: 'Total qualified REIT dividends and PTP (loss) carryforward',
                line: 'Line 40',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
        ],
    },
    {
        section: 'Other Ones',
        fields: [
            {
                name: 'contributionMade457_1',
                text: 'Contribution made to plan 457',
                line: 'Form 8880 Line 2',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'contributionMade457_2',
                text: 'Spouse contribution made to plan 457',
                line: 'Form 8880 Line 2',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'line3form2441',
                text: 'line 3 form 2441',
                line: 'Line 3 form 2441',
                type: 'number',
                inputType: 'number',
                defaultValue: 0,
            },
            {
                name: 'clientHasForm2441',
                text: 'Has Form 2441?',
                type: 'string',
                options: ['Yes', 'No'],
                inputType: 'radiobutton',
                defaultValue: 'No',
            },
            {
                name: 'hasChildren',
                text: 'Has children?',
                type: 'string',
                options: ['Yes', 'No'],
                inputType: 'radiobutton',
                defaultValue: 'No',
            },
            {
                name: 'clientHasForm1120',
                text: 'Has Form 1120?',
                type: 'string',
                options: ['Yes', 'No'],
                inputType: 'radiobutton',
                defaultValue: 'No',
            },
            {
                name: 'clientHasForm8839',
                text: 'Has Form 8839?',
                type: 'string',
                options: ['Yes', 'No'],
                inputType: 'radiobutton',
                defaultValue: 'No',
            },
            {
                name: 'clientHasForm6251',
                text: 'Has Form 6251?',
                type: 'string',
                options: ['Yes', 'No'],
                inputType: 'radiobutton',
                defaultValue: 'No',
            },
            {
                name: 'clientHasForm5695',
                text: 'Has Form 5695?',
                type: 'string',
                options: ['Yes', 'No'],
                inputType: 'radiobutton',
                defaultValue: 'No',
            },
            {
                name: 'clientHasForm5498',
                text: 'Has Form 5498?',
                type: 'string',
                options: ['Yes', 'No'],
                inputType: 'radiobutton',
                defaultValue: 'No',
            },
            {
                name: 'clientHasForm8959',
                text: 'Has Form 8959?',
                type: 'string',
                options: ['Yes', 'No'],
                inputType: 'radiobutton',
                defaultValue: 'No',
            },
            {
                name: 'clientHasForm2555',
                text: 'Has Form 2555?',
                type: 'string',
                options: ['Yes', 'No'],
                inputType: 'radiobutton',
                defaultValue: 'No',
            },
            {
                name: 'clientHasForm4562',
                text: 'Has Form 4562?',
                type: 'string',
                options: ['Yes', 'No'],
                inputType: 'radiobutton',
                defaultValue: 'No',
            },
            {
                name: 'clientHasForm8960',
                text: 'Has Form 8960?',
                type: 'string',
                options: ['Yes', 'No'],
                inputType: 'radiobutton',
                defaultValue: 'No',
            },
            {
                name: 'clientHasForm8880',
                text: 'Has Form 8880?',
                type: 'string',
                options: ['Yes', 'No'],
                inputType: 'radiobutton',
                defaultValue: 'No',
            },
            {
                name: 'clientHasForm1120s',
                text: 'Has Form 1120s?',
                type: 'string',
                options: ['Yes', 'No'],
                inputType: 'radiobutton',
                defaultValue: 'No',
            },
            {
                name: 'clientHasForm8863',
                text: 'Has Form 8863?',
                type: 'string',
                options: ['Yes', 'No'],
                inputType: 'radiobutton',
                defaultValue: 'No',
            },
        ],
    },
];

export default fulltax_2024;
